export default "__VITE_ASSET__CZvwhfj4__"